import React from 'react'
import PropTypes from 'prop-types'

// Api
import { downloadPaymentPOP } from 'api/payment'

// Models
import PaymentBreakdownModel from 'models/PaymentBreakdown'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Services
import message from 'services/message'

// Compoments
import Text from 'ui/Text'
import FileItemAttachment from 'ui/FileItem/FileItemAttachment'

export const PaymentPOP = ({ payment }) => {
  const onDownloadPaymentPopClick = async (name, setLoading) => {
    try {
      setLoading(true)
      return await downloadPaymentPOP({
        paymentId: payment.id,
        fileName: name,
      })
    } catch (error) {
      message.error(await resolveErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Text bold color="#070707">
        Proof of payment
      </Text>
      {payment.proofOfPayment && (
        <FileItemAttachment
          name={payment.proofOfPayment}
          onClick={onDownloadPaymentPopClick}
        />
      )}
    </>
  )
}

PaymentPOP.propTypes = {
  payment: PropTypes.instanceOf(PaymentBreakdownModel),
}

PaymentPOP.defaultProps = {
  payment: new PaymentBreakdownModel(),
}

export default PaymentPOP
